module.exports = __webpack_public_path__ + "img/SES_38083060.e62b2ea1.jpg";